var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-bottom"),React.createElement("path",{"id":"a","d":"M-10.66-36","fill":"none","key":1}),React.createElement("path",{"d":"M3.18,0V19.75h-1V0Z","fill":"#1a1919","fillRule":"evenodd","key":2}),React.createElement("path",{"d":"M.71,17.16l2.71,2.72-.7.71L0,17.87Z","fill":"#1a1919","fillRule":"evenodd","key":3}),React.createElement("path",{"d":"M4.73,17.16,2.25,19.63l.71.71,2.47-2.47Z","fill":"#1a1919","fillRule":"evenodd","key":4})]);
}

ArrowBottom.defaultProps = {"id":"Слой_1","data-name":"Слой 1","width":"5.43","height":"20.59","viewBox":"0 0 5.43 20.59"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
